import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

interface UserSummaryTableProps {
  totalUsers: number;
}

export const UserSummaryTable = ({ totalUsers }: UserSummaryTableProps) => {
  return (
    <Box sx={{ flex: 1 }}>
      <TableContainer>
        <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>유저 수</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>전체</TableCell>
                <TableCell>{totalUsers}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
      </TableContainer>
    </Box>
  );
}; 